import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';

import Icon from '../../../../components/Icon';
import Text from '../../../../components/Text';
import { $l } from '../../../../locales';
import { makeQAAttributes } from '../../../../utils/qaAttributes';
import { QA_HELP_CENTER } from '../../../../constants/qaAttributes';

const pointerStyles = { cursor: 'pointer' };

function CardItem({
  category: {
    name, icon, image, description, link, slug,
  },
}) {
  const history = useHistory();

  const handleClick = () => {
    history.push(link);
  };

  let iconEl = null;
  if (icon && icon.url) {
    iconEl = <img src={icon.url} alt="Category icon" width="32px" height="32px" />;
  } else if (image) {
    iconEl = <Icon id={image} size="32" />;
  }

  return (
    <div
      className="sp-help-cards__item"
      style={pointerStyles}
      onClick={handleClick}
      {...makeQAAttributes(`${QA_HELP_CENTER.CARD_ITEM}-${slug}`)}
    >
      <div className="sp-help-card">
        <div className="sp-help-card__body">
          <div className="sp-help-card__section">
            <div className="sp-help-card__icon">
              {iconEl}
            </div>
            <div className="sp-help-card__title">
              <Text element="h4" {...makeQAAttributes(QA_HELP_CENTER.CARD_ITEM_TITLE)}>{name}</Text>
            </div>
          </div>
          {description && (
            <div className="sp-help-card__desc">
              <Text {...makeQAAttributes(QA_HELP_CENTER.CARD_ITEM_DESCRIPTION)}>{description}</Text>
            </div>
          )}
          {link && (
            <div className="sp-help-card__section">
              <Link to={link} className="sp-help-card__link" {...makeQAAttributes(QA_HELP_CENTER.CARD_ITEM_LINK)}>
                {$l('READ_MORE')}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

CardItem.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    icon: PropTypes.shape({ url: PropTypes.string }),
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default CardItem;
